import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { compact, forEach, keys, set } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class FormValidationService {
  getValidationErrors(
    group: FormGroup,
    validationMessages: Record<string, Record<string, string>>,
    parentKey?: string
  ): Record<string, string> {
    let formErrors: Record<string, string> = {};

    keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);

      formErrors[key] = '';
      if (abstractControl && !abstractControl.valid) {
        const messages = {
          ...validationMessages['default'],
          ...validationMessages['generic'],
          ...validationMessages[key],
        };

        forEach(abstractControl.errors, (value, errorKey) => {
          if (errorKey && messages) {
            set(formErrors, compact([parentKey, key]), {
              message: messages[errorKey],
              params: value,
            });
          }
        });
      }

      if (abstractControl instanceof FormGroup) {
        const groupError = this.getValidationErrors(
          abstractControl,
          validationMessages,
          key
        );
        formErrors = { ...formErrors, ...groupError };
      }
    });
    return formErrors;
  }
}
